import { Icon } from '../icon.tsx';
import type { IconProps } from '../icon.tsx';

export function IconChevronDown(props: IconProps) {
	return (
		<Icon stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" {...props}>
			<path d="M6 9l6 6l6 -6" />
		</Icon>
	);
}
